export default "__VITE_ASSET__Di6bbsoU__"